module.exports = __webpack_public_path__ + "static/media/Paloma Ave, Burlingame, CA8.703b801c.jpg";